export const version = "abstract-provider/5.5.1";
